import React from 'react';
import { Card } from '../ui/card';
import { NoticesCard, VehiclesCard } from './operations/NoticesVehicleCards';
import { FacilitiesCard } from './operations/FacilitiesCard';
import { NoticeModal, VehicleModal, FacilityModal, PaymentModal, SlotManagementModal } from './operations/OperationModals';

export function OperationsTab({
  notices, vehicles, facilities,
  handleDeleteNotice, handleDeleteVehicle, handleDeleteFacility, handleManageSlots,
  showNoticeModal, setShowNoticeModal, noticeForm, setNoticeForm, handleCreateNotice,
  showVehicleModal, setShowVehicleModal, vehicleForm, setVehicleForm, handleAddVehicle,
  showFacilityModal, setShowFacilityModal, facilityForm, setFacilityForm, handleCreateFacility,
  showPaymentModal, setShowPaymentModal, paymentForm, setPaymentForm, handleCreatePayment,
  showSlotManagementModal, setShowSlotManagementModal, selectedFacility,
  slotManagementForm, setSlotManagementForm, handleBlockSlot, handleUnblockSlot,
  reloadData,
  config
}) {
  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <NoticesCard notices={notices} onDelete={handleDeleteNotice} onCreate={() => setShowNoticeModal(true)} />
        <VehiclesCard vehicles={vehicles} onDelete={handleDeleteVehicle} onCreate={() => setShowVehicleModal(true)} onChange={reloadData} />
      </div>

      {config?.facility_booking_enabled !== false && (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
          <FacilitiesCard facilities={facilities} onDelete={handleDeleteFacility} onCreate={() => setShowFacilityModal(true)} onManageSlots={handleManageSlots} />
          <Card className="shadow-lg border-0">{/* Invoice Generator hidden for future release */}</Card>
        </div>
      )}

      <NoticeModal open={showNoticeModal} onOpenChange={setShowNoticeModal} form={noticeForm} setForm={setNoticeForm} onSubmit={handleCreateNotice} />
      <VehicleModal open={showVehicleModal} onOpenChange={setShowVehicleModal} form={vehicleForm} setForm={setVehicleForm} onSubmit={handleAddVehicle} />
      <FacilityModal open={showFacilityModal} onOpenChange={setShowFacilityModal} form={facilityForm} setForm={setFacilityForm} onSubmit={handleCreateFacility} />
      <PaymentModal open={showPaymentModal} onOpenChange={setShowPaymentModal} form={paymentForm} setForm={setPaymentForm} onSubmit={handleCreatePayment} />
      <SlotManagementModal open={showSlotManagementModal} onOpenChange={setShowSlotManagementModal} facility={selectedFacility} form={slotManagementForm} setForm={setSlotManagementForm} onBlock={handleBlockSlot} onUnblock={handleUnblockSlot} />
    </>
  );
}
